/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clubs_Join_LookupInputs */

const en_us2_clubs_join_lookup = /** @type {(inputs: Clubs_Join_LookupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continue`)
};

const pt_br2_clubs_join_lookup = /** @type {(inputs: Clubs_Join_LookupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continuar`)
};

const es_419_clubs_join_lookup = /** @type {(inputs: Clubs_Join_LookupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continuar`)
};

const pt_pt2_clubs_join_lookup = /** @type {(inputs: Clubs_Join_LookupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continuar`)
};

const fr_fr2_clubs_join_lookup = /** @type {(inputs: Clubs_Join_LookupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continuer`)
};

const de_de2_clubs_join_lookup = /** @type {(inputs: Clubs_Join_LookupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weiter`)
};

const it_it2_clubs_join_lookup = /** @type {(inputs: Clubs_Join_LookupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continua`)
};

/**
* | output |
* | --- |
* | "Continue" |
*
* @param {Clubs_Join_LookupInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const clubs_join_lookup = /** @type {((inputs?: Clubs_Join_LookupInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clubs_Join_LookupInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_clubs_join_lookup(inputs)
	if (locale === "es-419") return es_419_clubs_join_lookup(inputs)
	if (locale === "pt-PT") return pt_pt2_clubs_join_lookup(inputs)
	if (locale === "fr-FR") return fr_fr2_clubs_join_lookup(inputs)
	if (locale === "de-DE") return de_de2_clubs_join_lookup(inputs)
	if (locale === "it-IT") return it_it2_clubs_join_lookup(inputs)
	return en_us2_clubs_join_lookup(inputs)
});
export { clubs_join_lookup as "clubs.join_lookup" }